import React from 'react';
import './expenses.css';
export default function MonthlySummary({ budget = 0, expenses = [] }) {
    // Filter current month expenses
    const getCurrentMonthExpenses = (expenses) => {
        const now = new Date();
        return expenses.filter(exp => {
            const expDate = new Date(exp.date);
            return (
                expDate.getMonth() === now.getMonth() &&
                expDate.getFullYear() === now.getFullYear()
            );
        });
    };

    const monthlyExpenses = getCurrentMonthExpenses(expenses);

    // Calculate total spent
    const totalSpent = monthlyExpenses.reduce((sum, e) => sum + (e.amount || 0), 0);

    // Find highest single expense
    const highestExpense = monthlyExpenses.reduce(
        (max, e) => (e.amount > max ? e.amount : max),
        0
    );

    // Determine top category
    const topCategory = (() => {
        const categoryTotals = {};
        monthlyExpenses.forEach(e => {
            if (e.category) {
                categoryTotals[e.category] = (categoryTotals[e.category] || 0) + e.amount;
            }
        });

        const sortedCategories = Object.entries(categoryTotals).sort((a, b) => b[1] - a[1]);
        return sortedCategories.length > 0 ? sortedCategories[0][0] : 'N/A';
    })();

    return (
        <div className="row summary-card">
    <div className="col-lg-6 col-md-6 col-sm-12 mb-3 summary-card">
        <div className="card summary-card h-100 shadow-sm border-0 bg-light">
            <div className="card-body d-flex flex-column justify-content-center align-items-start">
                <h6 className="text-muted text-uppercase">Total Spent</h6>
                <h4 className="text-dark fw-bold">₹{totalSpent.toFixed(2)}</h4>
            </div>
        </div>
    </div>

    <div className="col-lg-6 col-md-6 col-sm-12 mb-3 summary-card">
        <div className="card summary-card h-100 shadow-sm border-0 bg-light">
            <div className="card-body d-flex flex-column justify-content-center align-items-start">
                <h6 className="text-muted text-uppercase">Budget Remaining</h6>
                <h4 className="text-dark fw-bold">₹{(budget - totalSpent).toFixed(2)}</h4>
            </div>
        </div>
    </div>

    <div className="col-lg-6 col-md-6 col-sm-12 mb-3 summary-card">
        <div className="card summary-card h-100 shadow-sm border-0 bg-light">
            <div className="card-body d-flex flex-column justify-content-center align-items-start">
                <h6 className="text-muted text-uppercase">Highest Expense</h6>
                <h4 className="text-dark fw-bold">₹{highestExpense.toFixed(2)}</h4>
            </div>
        </div>
    </div>
 
    <div className="col-lg-6 col-md-6 col-sm-12 mb-3 summary-card">
        <div className="card summary-card h-100 shadow-sm border-0 bg-light">
            <div className="card-body d-flex flex-column justify-content-center align-items-start">
                <h6 className="text-muted text-uppercase">Top Category</h6>
                <h4 className="text-dark fw-bold">{topCategory}</h4>
            </div>
        </div>
    </div>
</div>



    );
}
